var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelehealth = function SvgTelehealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.335 4.918c12.565 0 22.75 10.186 22.75 22.75 0 12.566-10.185 22.75-22.75 22.75s-22.75-10.184-22.75-22.75c0-12.564 10.185-22.75 22.75-22.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M28.333 52.169h-14.77v-49h14.77l7.385 27.09-7.386 21.892z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M28.335 3.168h14.77v49h-14.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.336 43.156H16.208V5.81h12.128l6.072 20.65z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M28.335 5.81h12.127v37.346H28.335z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.332 49.385h-4.83v-3.43h4.83l2.415 1.907-2.415 1.54z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M28.335 45.938h4.83v3.43h-4.83z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M28.333 27.282h-1.365v6.213a4.9 4.9 0 0 0 1.365 3.395l.805-5.338z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M34.075 33.495a2.188 2.188 0 0 1-4.375 0v-6.213h-1.365v9.608a4.86 4.86 0 0 0 3.552 1.522 4.92 4.92 0 0 0 4.918-4.917V31.71h-2.73z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M23.485 20.544h-2.17V10.69h3.954v2.17h-1.802v7.683zM35.329 20.544h-2.17V12.86h-1.803v-2.17h3.955v9.853z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M25.76 13.475a1.698 1.698 0 1 0 0-3.395 1.698 1.698 0 0 0 0 3.395M30.908 13.475a1.698 1.698 0 1 0 0-3.395 1.698 1.698 0 0 0 0 3.395"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC2B4",
    d: "M28.333 28.735c-4.06 0-7.367-3.308-7.367-7.368V19.11h2.887v2.257a4.49 4.49 0 0 0 4.48 4.48l1.243 1.348z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M32.815 21.367a4.49 4.49 0 0 1-4.48 4.48v2.888c4.06 0 7.368-3.308 7.368-7.368V19.11h-2.888z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M35.333 33.6a2.957 2.957 0 1 0 0-5.914 2.957 2.957 0 0 0 0 5.914"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M35.332 32.13a1.487 1.487 0 1 0 0-2.975 1.487 1.487 0 0 0 0 2.975"
  })));
};
export default SvgTelehealth;